import { render, staticRenderFns } from "./Facts.vue?vue&type=template&id=571f3a66&scoped=true&"
import script from "./Facts.vue?vue&type=script&lang=js&"
export * from "./Facts.vue?vue&type=script&lang=js&"
import style0 from "./Facts.vue?vue&type=style&index=0&id=571f3a66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571f3a66",
  null
  
)

export default component.exports